import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import DefaultPropTypes from "../../utils/prop-types";
import setupErrorMsg from "../../../../../js/feature/cookie-consent-error";
import Loader from "../../../../../js/project/loader-react";

const VideoGalleryItemDetailView = ({ selectedItem, onClose }) => {
  const [showErrorMsg, setShowErrorMsg] = useState(false);
  const videoContainerRef = React.createRef();

  useEffect(() => {
    setShowErrorMsg(
      !!window.CookieInformation &&
        !window.CookieInformation.getConsentGivenFor("cookie_cat_marketing")
    );
    const observerTargetNode = document.getElementById("coiOverlay");
    const observerConfig = { attributes: true, attributeFilter: ["style"] };
    const callback = () => {
      const shouldShowError =
        !!window.CookieInformation &&
        !window.CookieInformation.getConsentGivenFor("cookie_cat_marketing");
      setShowErrorMsg(shouldShowError);
    };
    const observer = new MutationObserver(callback);
    if (!!window.CookieInformation) {
      observer.observe(observerTargetNode, observerConfig);
    }
    return () => {
      observer.disconnect();
    };
  }, []);

  useEffect(() => {
    setupErrorMsg(videoContainerRef.current);
  }, [videoContainerRef]);

  const blockClick = (e) => {
    e.stopPropagation();
  };

  const createIframeWithAutoplay = (iframeCode) => {
    const iframeParts = iframeCode.split(" ");
    const src = iframeParts.findIndex((el) => el.includes("src"));
    iframeParts[src] = iframeParts[src].slice(0, -1) + "?autoplay=1'";
    return iframeParts.join(" ").replace(/\[/g, "<").replace(/\]/g, ">");
  };

  return (
    <div
      className="detail-lightbox outer-container"
      onClick={onClose}
      onKeyUp={(e) => e.key === "Enter" && onClose}
      role="button"
      tabIndex="-20"
      id={`detail-${selectedItem.id}`}
    >
      <button
        className="lightbox-close"
        aria-label="close"
        onClick={onClose}
        onKeyUp={(e) => e.key === "Enter" && onClose}
      >
        &#xe20f;
      </button>
      <div
        className="inner-container"
        onClick={(e) => blockClick(e)}
        onKeyUp={(e) => blockClick(e)}
        role="button"
        tabIndex="-10"
      >
        {showErrorMsg ? (
          <div className="video-container__error">
            <div
              className="video-container__error__container"
              ref={videoContainerRef}
            />
          </div>
        ) : (
          <>
            <div
              className="video-container"
              dangerouslySetInnerHTML={{
                __html: createIframeWithAutoplay(selectedItem.url),
              }}
            />
            <Loader />
          </>
        )}
      </div>
    </div>
  );
};

VideoGalleryItemDetailView.propTypes = {
  onClose: PropTypes.func.isRequired,
  item: DefaultPropTypes.item.isRequired,
};

export default VideoGalleryItemDetailView;
